import { CertificateTrainingPeriod } from './models/CertificateExportRequest';
import { CertificateLanguage } from './models/CertificateLanguage';

// Names the downloaded file itself, so responses carry no file name. The PDFs inside a bundle are
// named by the backend (CertificateFileName.cs), because the zip is streamed from the server and
// renaming its entries here would mean rebuilding the whole archive in the browser. Keep the
// prefixes in sync with it.
const CERTIFICATE_PREFIXES: Record<CertificateLanguage, string> = {
  [CertificateLanguage.GERMAN]: 'Zertifikat',
  [CertificateLanguage.ENGLISH]: 'Certificate',
};

const BUNDLE_PREFIXES: Record<CertificateLanguage, string> = {
  [CertificateLanguage.GERMAN]: 'Zertifikate',
  [CertificateLanguage.ENGLISH]: 'Certificates',
};

function sanitize(value: string): string {
  return value.replace(/[^\p{L}\p{N}()]+/gu, '_').replace(/^_+|_+$/g, '');
}

function buildFileName(
  prefix: string,
  subjects: string[],
  extension: string,
  suffix: string,
): string {
  const parts = [prefix, ...subjects.map(sanitize)].filter(
    (part) => part.length > 0,
  );
  return `${parts.join('_')}${suffix}${extension}`;
}

export function certificateFileName(
  language: CertificateLanguage,
  subjects: string[],
  completedOn?: string,
): string {
  return buildFileName(
    CERTIFICATE_PREFIXES[language],
    subjects,
    '.pdf',
    completedOn ? `_${completedOn}` : '',
  );
}

export function certificateBundleFileName(
  language: CertificateLanguage,
  subjects: string[],
  period?: CertificateTrainingPeriod,
): string {
  return buildFileName(
    BUNDLE_PREFIXES[language],
    subjects,
    '.zip',
    period
      ? `_[${period.startDate.slice(0, 10)}_${period.endDate.slice(0, 10)}]`
      : '',
  );
}
